export default "__VITE_ASSET__B0CE8Jdh__"